import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Table, List } from "semantic-ui-react";
import Axios from "axios";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import {SUCCESS_MESSAGES , ERROR_MESSAGES} from '../../utils/validationConstant'
import {LOCAL_STORAGE} from '../../utils/constant'
import cogoToast from "cogo-toast";

const OrderImportFile = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [fileErrors, setfileErrors] = useState([]);
  const [fileErrorsflag, setfileErrorsFlag] = useState(false);
  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = async () => {
    let fileName = props.fileName;
    let url
    if (props.allotedOrder) {
      url = `${process.env.REACT_APP_TA_API_URL}/shipments/download/sampleExcel?file_name=invoiceImport&customer_no=${LOCAL_STORAGE.customerNo}&user_id=${LOCAL_STORAGE.userId}`;
    } else {
      url = `${process.env.REACT_APP_TA_API_URL}/shipments/download/sampleExcel?customer_no=${LOCAL_STORAGE.customerNo}&user_id=${LOCAL_STORAGE.userId}`;
    }
    window.location.href = url;
  };
  
  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
    } else {
      let fromData = new FormData();
      fromData.append("customerNumber", LOCAL_STORAGE.customerNo);
      fromData.append("userId", LOCAL_STORAGE.userId);
      fromData.append("customer_no", LOCAL_STORAGE.customerNo);
      fromData.append("user_id", LOCAL_STORAGE.userId);
      var gett = LOCAL_STORAGE.userToken
      let url
      if (props.allotedOrder) {
        fromData.append("file", file);
        url = `${process.env.REACT_APP_TA_API_URL}/orders/allocated_state/excel/upload`;
      } 
      Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          if (response?.data?.resultSet?.skipped_records?.length > 0) {
            setfileErrorsFlag(true);
            setfileErrors(
              response.data.resultSet.skipped_records.length > 0
                ? response.data.resultSet.skipped_records
                : []
            );
          } else {
            if(response.data.resultSet.skipped_records.length == 0){
              setfileErrorsFlag(false);
            cogoToast.success(response?.data?.message ? response.data.message : `Uploaded Delivery Plan excel.`,{hideAfter:0})           
            }
            setTimeout(() => {
              props.handleClose()
            }, 1000);
          }
        })
        .catch((err) => {
          props.error({
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.message||ERROR_MESSAGES.IMPORT_FAILED,
          });
          setisloading(false);
          console.log(">> err", err);
        });
    }
  };

  const { t } = props;
  return (
    <>

      <div>
        <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
          {fileErrorsflag == true ? (
            <>
              <Header>{t("title") || "Import File"}</Header>
              <Modal.Content scrolling>
                <Modal.Description style={{ height: "300px", overflow: 'scroll' }}>
                  {fileErrors.map((object, index) => (
                    <List bulleted>
                      <List.Item style={{ fontWeight: '14px' }}>{object}</List.Item>
                    </List>
                  ))}
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={props.handleClose} size="mini">
                  {t("cancel") || "Cancel"}
                </Button>
              </Modal.Actions>
            </>
          ) : (
            <>
              <Header>{t("title") || "Import File"}</Header>
              <Modal.Content>
                <Modal.Description>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-600">
                        {t("message") || "Import Data Using Excel Sheet(Format- xls,xlsx)."}
                      </label>
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                        {t("upload_file") || "Upload File"} &nbsp;
                      </label>
                      <input
                        onChange={handleFile}
                        type="file"
                        className="w3-small"
                        id="validatedCustomFile"
                      />
                    </FormUi.Field>
                    <FormUi.Field>
                      <label className="tiny ui form pt-3">
                        <span className="p-bold-600 ">
                          {t("download") || "Download Excel Template from"}{" "}
                          <span
                            className="w3-text-blue p-bold-300"
                            onClick={templateDownload}
                            style={{ cursor: "pointer" }}
                          >
                            {t("here") || "Here"}
                          </span>
                        </span>
                      </label>
                    </FormUi.Field>
                  </FormUi.Group>
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                {isloading ? <small>Loading...</small> : ""}
                <Button onClick={props.handleClose} size="mini">
                  {t("cancel") || "Cancel"}
                </Button>
                <Button
                  onClick={handleUpload}
                  disabled={isloading ? true : false}
                  color="blue"
                  size="mini"
                >
                  {t("upload") || "Upload"}
                </Button>
              </Modal.Actions>

            </>
          )}
        </Modal>
      </div>

    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(null, mapDispatchToProps)(translate("importfilemaster")(OrderImportFile));
